import { jsx as _jsx } from "react/jsx-runtime";
import { EmptySearchResult } from './empty-search-result';
import { EmptyScheduledList } from './empty-scheduled-list';
import { EmptyDraftsList } from './empty-drafts-list';
import { EmptySentList } from './empty-sent-list';
var componentByState = {
    search: EmptySearchResult,
    scheduled: EmptyScheduledList,
    draft: EmptyDraftsList,
    completed: EmptySentList,
};
export var EmptyResults = function (_a) {
    var emptyTableState = _a.emptyTableState;
    var EmptyResultsComponent = componentByState[emptyTableState];
    if (!EmptyResultsComponent) {
        return null;
    }
    return _jsx(EmptyResultsComponent, {});
};
